import { render, staticRenderFns } from "./FormDigestEdit.vue?vue&type=template&id=70639221"
import script from "./FormDigestEdit.vue?vue&type=script&lang=js"
export * from "./FormDigestEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports